import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { toCbBranch } from './branch-shape';

// cb-client-admin-api's branch read when no 3PL partner is set.
const NO_PARTNER = { name: '', hooks: { created: '' } };

/**
 * `POST /client/:cid/branch/:id` (a read on POST) gives the branch with its hub but leaves out `dashboard_url` and
 * `logo`, so those come from the branch list. The 3PL partner comes from `GET /client/:cid/branches/:id/three-pl`.
 */
export const getBranch = async (branch_id: string): Promise<any> => {
  const [branch, branches, partners] = await Promise.all([
    lpRequest('POST', clientPath(`/branch/${branch_id}`)),
    lpRequest('GET', clientPath('/branch')),
    lpRequest('GET', clientPath(`/branches/${branch_id}/three-pl`))
  ]);
  const listed = (branches || []).find((item: any) => item.id === branch_id) || {};

  // The single read maps a `{_latitude, _longitude}` stored location to `{}`; the list keeps it.
  return {
    ...toCbBranch({ ...listed, ...branch, location: listed.location ?? branch.location }),
    // The payment form calls the stored `acquirer_name` its payment provider.
    payment_fields: branch.payment_fields?.map((provider: any) => ({
      ...provider,
      payment_provider: provider.payment_provider ?? provider.acquirer_name
    })),
    three_pl_partners: (partners || [])[0] || NO_PARTNER
  };
};
